import React, { useState } from 'react';
import {
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { actions } from '../stateMgmt';
import { useApp } from '../stateMgmt/AppContext';

export function FloorNavigator() {
  const { building, dispatch, currentFloorId, setCurrentFloorId } = useApp();
  
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [floorToDelete, setFloorToDelete] = useState(null);

  const handleDeleteClick = (floorId) => {
    if (building?.floors.length <= 1) {
      alert('לא ניתן למחוק את הקומה האחרונה');
      return;
    }
    setFloorToDelete(floorId);
    setDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (floorToDelete) {
      dispatch({type: actions.REMOVE_FLOOR, payload: {floorId: floorToDelete}});
      setDeleteConfirmOpen(false);
      setFloorToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmOpen(false);
    setFloorToDelete(null);
  };

  const currentFloor = building?.floors.find(f => f.id === currentFloorId) ?? building?.floors[0];
  const [selectOpen, setSelectOpen] = useState(false);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    if (value === 'add') {
      dispatch({type: actions.ADD_FLOOR});
      setSelectOpen(false);
    } else if (value && value.startsWith('delete-')) {
      const floorId = value.replace('delete-', '');
      handleDeleteClick(floorId);
      setSelectOpen(false);
    } else if (value) {
      setCurrentFloorId(value);
    }
  };

  const handleDeleteIconClick = (e, floorId) => {
    e.stopPropagation();
    handleDeleteClick(floorId);
    setSelectOpen(false);
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          backgroundColor: 'background.default',
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="body1" fontWeight="bold">קומה:</Typography>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>בחר קומה</InputLabel>
            <Select
              value={currentFloor.id || ''}
              onChange={handleSelectChange}
              onOpen={() => setSelectOpen(true)}
              onClose={() => setSelectOpen(false)}
              open={selectOpen}
              label="בחר קומה"
              renderValue={(value) => {
                const index = building?.floors.findIndex(f => f.id === value);
                return  index > -1 ? `קומה ${index}` : '?';
              }}
            >
              {building?.floors.map((floor, index) => (
                <MenuItem 
                  key={floor.id} 
                  value={floor.id}
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <span>{`קומה ${index}`}</span>
                  {selectOpen && building.floors.length > 1 && (
                    <IconButton
                      size="small"
                      onClick={(e) => handleDeleteIconClick(e, floor.id)}
                      sx={{ ml: 1 }}
                      color="error"
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  )}
                </MenuItem>
              ))}
              <Divider />
              <MenuItem value="add">
                <ListItemIcon>
                  <AddIcon fontSize="small" color="success" />
                </ListItemIcon>
                <ListItemText>הוסף קומה</ListItemText>
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>

      <Dialog
        open={deleteConfirmOpen}
        onClose={handleDeleteCancel}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          מחיקת קומה
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            האם אתה בטוח שברצונך למחוק את הקומה "{currentFloor?.name}"? כל החדרים בקומה זו יימחקו גם כן.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            ביטול
          </Button>
          <Button onClick={handleDeleteConfirm} color="error" variant="contained" autoFocus>
            מחק
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

